import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { isAdminUser } from "../utils/roleUtils";
import { getUiChildren } from "../utils/uiConfig";
import { getUiIcon } from "../utils/uiIcons";
import "./CustomersHome.css";

function CustomersHome() {
  const navigate = useNavigate();
  const { user, uiConfig } = useContext(AuthContext);
  const isAdmin = isAdminUser(user);

  const tools = useMemo(
    () =>
      getUiChildren(uiConfig, "customers", { isAdmin }).map((item) => ({
        ...item,
        Icon: getUiIcon(item.icon),
      })),
    [isAdmin, uiConfig]
  );

  return (
    <div className="customers-wrapper">
      <div className="customers-header">
        <h2 className="customers-title-main">Customers</h2>
      </div>
      <div className="customers-container">
        {tools.map((tool) => {
          const Icon = tool.Icon;
          return (
            <div
              key={tool.id}
              className="customers-tool-card"
              onClick={() => navigate(tool.route)}
              style={{ "--accent-color": tool.accentColor || "#3b82f6" }}
            >
              <div className="customers-icon-box">
                <Icon />
              </div>
              <div className="customers-card-content">
                <h3 className="customers-tool-name">{tool.label}</h3>
                <p className="customers-tool-desc">{tool.description}</p>
              </div>
              <div className="customers-card-arrow">-></div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default CustomersHome;
